/* Mewnook Nook — core: cart, drawer, reveal, parallax, header, utilities. No dependencies. */
(function () {
  'use strict';
  var MN = window.MN = window.MN || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  MN.$ = $; MN.$$ = $$;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  MN.reduceMotion = reduce;

  /* ---------- money ---------- */
  MN.money = function (cents) {
    var v = (cents / 100);
    var s = v.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return '£' + (s.slice(-3) === '.00' && v % 1 === 0 ? s.slice(0, -3) : s);
  };
  MN.esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- toast ---------- */
  var toastT;
  MN.toast = function (msg) {
    var t = $('#mnToast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove('is-on'); }, 2800);
  };

  /* ---------- cart ---------- */
  var cartState = null;
  function json(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts)).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) { var e = new Error(d.description || d.message || 'Cart error'); e.data = d; throw e; } return d; });
    });
  }
  MN.cart = {
    get: function () { return json('/cart.js').then(function (c) { cartState = c; render(c); return c; }); },
    add: function (items) {
      return json(MN.routes.cartAdd + '.js', { method: 'POST', body: JSON.stringify({ items: items }) }).then(function () { return MN.cart.get(); });
    },
    change: function (line, quantity) {
      return json(MN.routes.cartChange + '.js', { method: 'POST', body: JSON.stringify({ line: line, quantity: quantity }) }).then(function (c) { cartState = c; render(c); return c; });
    },
    state: function () { return cartState; }
  };


  /* ---------- pre-add offer: "want these with it?" ---------- */
  MN.preAdd = function (items, ctx) {
    return new Promise(function (resolve) {
      var dataEl = $('#mnUpsellData'), list = [];
      try { list = JSON.parse(dataEl.textContent); } catch (e) {}
      var main = items[0], me = list.filter(function (p) { return p.handle === ctx.handle; })[0];
      var keys = (ctx.problems || '').split(',').filter(Boolean);
      var matches = function (p) { return keys.some(function (k) { return (p.problems || '').indexOf(k + ',') > -1; }); };
      var inKit = (ctx.components || '').split(',').filter(Boolean);
      list = list.filter(function (p) { return inKit.indexOf(p.handle) === -1; });
      var offers = [];
      if (ctx.kind === 'box' && !main.selling_plan && me && me.plan) offers.push({ type: 'monthly', id: 'monthly', title: 'Make it monthly', img: me.img, note: 'Save ' + MN.money(me.price - me.planPrice) + ' on every box, plus a free e-book gift. Skip, pause or cancel before the next box is packed.', price: me.planPrice, plan: me.plan });
      var eb = list.filter(function (p) { return p.kind === 'ebook' && p.available && matches(p); })[0];
      if (eb && ctx.kind !== 'kit' && ctx.kind !== 'box' && ctx.kind !== 'ebook') offers.push({ type: 'add', id: eb.vid, title: eb.title.replace(' (e-book)', '') + ' e-book', img: eb.img, note: 'Illustrated PDF, emailed straight away. Included free with our kits.', price: eb.price });
      if (ctx.kind === 'item' || ctx.kind === 'ebook') { var kit = list.filter(function (p) { return p.kind === 'kit' && p.available && matches(p) && p.handle !== ctx.handle; })[0]; if (kit) offers.push({ type: 'add', id: kit.vid, title: kit.title, img: kit.img, note: 'Several items together, free UK delivery, e-book included.', price: kit.price }); }
      if (ctx.kind === 'item' || ctx.kind === 'kit') { var bx = list.filter(function (p) { return p.kind === 'box' && p.available && matches(p); })[0]; if (bx) offers.push({ type: 'add', id: bx.vid, title: bx.title, img: bx.img, note: 'Your first box ' + MN.money(bx.price - 1000) + ' with code FIRST25 (normally ' + MN.money(bx.price) + ').', price: bx.price - 1000, code: 'FIRST25' }); }
      list.filter(function (p) { return p.kind === 'addon' && p.available && p.handle !== ctx.handle && matches(p); }).slice(0, 2).forEach(function (a) { offers.push({ type: 'add', id: a.vid, title: a.title, img: a.img, note: 'Goes with your plan.', price: a.price }); });
      if (!offers.length) { var cs = (ctx.cats || '').split(',').filter(Boolean); var sameCat = function (p) { return cs.some(function (k) { return (p.cats || '').indexOf(k + ',') > -1; }); };
        list.filter(function (p) { return p.handle !== ctx.handle && p.available && p.kind !== 'box' && p.kind !== 'ebook' && p.price <= 2500 && (cs.length ? sameCat(p) : p.kind === 'addon'); }).slice(0, 3).forEach(function (a) { offers.push({ type: 'add', id: a.vid, title: a.title, img: a.img, note: 'Often added with this.', price: a.price }); }); }
      offers = offers.slice(0, 4);
      if (!offers.length) { resolve({ items: items }); return; }
      var wrap = document.createElement('div'); wrap.className = 'mn-pre'; wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true'); wrap.setAttribute('aria-label', 'Add something with it?');
      wrap.innerHTML = '<div class="mn-pre__box"><button type="button" class="mn-iconbtn mn-pre__x" data-pre-x aria-label="Close">×</button><p class="mn-eyebrow">Before it goes in your cart</p><h3>Want these with it?</h3><div class="mn-pre__list">' + offers.map(function (o, i) {
        return '<label class="mn-pre__o"><input type="checkbox" data-o="' + i + '"><span class="mn-pre__img">' + (o.img ? '<img src="' + MN.esc(o.img) + '" alt="" width="64" height="64">' : '') + '</span><span class="mn-pre__t"><b>' + MN.esc(o.title) + '</b><small>' + MN.esc(o.note) + '</small></span><span class="mn-pre__p">' + MN.money(o.price) + '</span></label>';
      }).join('') + '</div><button type="button" class="mn-btn mn-btn--lg mn-btn--block" data-pre-go>Add to cart</button><button type="button" class="mn-pre__skip" data-pre-skip>No thanks, just add it</button></div>';
      document.body.appendChild(wrap); document.documentElement.style.overflow = 'hidden';
      requestAnimationFrame(function () { wrap.classList.add('is-on'); });
      function done(res) { wrap.remove(); document.documentElement.style.overflow = ''; document.removeEventListener('keydown', onKey); resolve(res); }
      function onKey(e) { if (e.key === 'Escape') done(null); }
      document.addEventListener('keydown', onKey);
      var go = $('[data-pre-go]', wrap), cbs = $$('input[data-o]', wrap);
      function sync() { var n = cbs.filter(function (c) { return c.checked; }).length; go.textContent = n ? 'Add ' + (n + 1) + ' items to cart' : 'Add to cart'; }
      cbs.forEach(function (c) { c.addEventListener('change', sync); });
      wrap.addEventListener('click', function (e) {
        if (e.target === wrap || e.target.closest('[data-pre-x]')) return done(null);
        if (e.target.closest('[data-pre-skip]')) return done({ items: items });
        if (e.target.closest('[data-pre-go]')) {
          var out = [Object.assign({}, main)], code = '';
          cbs.forEach(function (c) { if (!c.checked) return; var o = offers[+c.getAttribute('data-o')]; if (o.type === 'monthly') out[0].selling_plan = o.plan; else { out.push({ id: parseInt(o.id, 10), quantity: 1 }); if (o.code) code = o.code; } });
          done({ items: out, code: code });
        }
      });
    });
  };

  function open(el, overlay) { el.classList.add('is-open'); overlay && overlay.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
  function close(el, overlay) { el.classList.remove('is-open'); overlay && overlay.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  MN.openCart = function () { var d = $('#mnDrawer'); if (!d) return; open(d, $('#mnOverlay')); d.querySelector('[data-close]') && d.querySelector('[data-close]').focus(); };
  MN.closeCart = function () { close($('#mnDrawer'), $('#mnOverlay')); };

  function planBadge(it) {
    var a = it.selling_plan_allocation; if (!a) return '';
    return '<span class="mn-line__plan">↻ ' + MN.esc(a.selling_plan.name) + '</span>';
  }
  function props(it) {
    var p = it.properties || {}, out = [];
    Object.keys(p).forEach(function (k) { if (k.charAt(0) !== '_' && p[k]) out.push(MN.esc(k) + ': ' + MN.esc(p[k])); });
    return out.length ? '<div class="mn-line__meta">' + out.join(' · ') + '</div>' : '';
  }
  function render(c) {
    var body = $('#mnDrawerLines'), foot = $('#mnDrawerFoot'), ship = $('#mnShip');
    var counts = $$('[data-cart-count]');
    counts.forEach(function (n) { n.textContent = c.item_count; n.classList.toggle('has-items', c.item_count > 0); });
    if (!body) return;
    if (!c.item_count) {
      body.innerHTML = '<div class="mn-drawer__empty"><span class="hand">Nothing here yet…</span><p>Your cat is waiting. Take the 60-second quiz and we’ll point you to the right box.</p><a class="mn-btn" href="/pages/find-your-nook">Find my cat’s Nook</a></div>';
      foot.hidden = true; ship.hidden = true; return;
    }
    foot.hidden = false; ship.hidden = false;
    body.innerHTML = c.items.map(function (it, i) {
      var line = i + 1;
      var price = it.final_line_price !== it.original_line_price ? '<s>' + MN.money(it.original_line_price) + '</s>' + MN.money(it.final_line_price) : MN.money(it.final_line_price);
      return '<div class="mn-line" data-line="' + line + '">' +
        '<a class="mn-line__img" href="' + it.url + '">' + (it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x160$1$2') + '" alt="" width="76" height="76" loading="lazy">' : '') + '</a>' +
        '<div><a class="mn-line__title" href="' + it.url + '">' + MN.esc(it.product_title) + '</a>' +
        (it.variant_title && it.variant_title !== 'Default Title' ? '<div class="mn-line__meta">' + MN.esc(it.variant_title) + '</div>' : '') +
        props(it) + planBadge(it) +
        '<div class="mn-qty"><button type="button" data-qty="-1" aria-label="Decrease">−</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="Increase">+</button></div>' +
        '<br><button class="mn-line__remove" type="button" data-remove>Remove</button></div>' +
        '<div class="mn-line__price">' + price + '</div></div>';
    }).join('');
    $('#mnSubtotal').textContent = MN.money(c.total_price);
    var save = c.total_discount; var sv = $('#mnSaved');
    if (sv) { sv.textContent = save > 0 ? 'You’re saving ' + MN.money(save) : ''; }
    // free-shipping bar counts only non-subscription lines (subscriptions always ship free)
    var hasSub = c.items.some(function (i) { return i.selling_plan_allocation; });
    var need = MN.freeShipping, have = c.total_price;
    var fill = $('.mn-ship__fill', ship), msg = $('#mnShipMsg');
    if (hasSub) { fill.style.setProperty('--p', '100%'); msg.innerHTML = '<span aria-hidden="true">🎉</span> Subscription boxes ship <b>free</b> to the UK.'; }
    else if (have >= need) { fill.style.setProperty('--p', '100%'); msg.innerHTML = '<span aria-hidden="true">🎉</span> You’ve unlocked <b>free UK delivery</b>!'; }
    else { fill.style.setProperty('--p', Math.round(have / need * 100) + '%'); msg.innerHTML = 'Add <b>' + MN.money(need - have) + '</b> more for free UK delivery'; }
    renderUpsell(c);
  }
  function renderUpsell(c) {
    var box = $('#mnUpsell'); if (!box) return;
    var dataEl = $('#mnUpsellData'); if (!dataEl) { box.hidden = true; return; }
    var list = []; try { list = JSON.parse(dataEl.textContent); } catch (e) {}
    var byHandle = {}; list.forEach(function (p) { byHandle[p.handle] = p; });
    var inCart = {}; c.items.forEach(function (i) { inCart[i.product_id] = true; });
    var probs = {}, hasBox = null, hasKit = false;
    c.items.forEach(function (i) { var p = byHandle[i.handle]; if (!p) return; (p.problems || '').split(',').forEach(function (t) { if (t) probs[t] = 1; }); if (p.kind === 'box') hasBox = i; if (p.kind === 'kit' || p.kind === 'item') hasKit = true; });
    var matches = function (p) { return Object.keys(probs).some(function (k) { return (p.problems || '').indexOf(k + ',') > -1; }); };
    var html = '', h;
    // 1) one-time box in the cart: offer monthly
    if (hasBox && !hasBox.selling_plan_allocation) {
      var bp = byHandle[hasBox.handle];
      if (bp && bp.plan) html = '<h4>Make it monthly</h4><div class="mn-upsell__row mn-upsell__row--noimg"><div><b>Save ' + MN.money(bp.price - bp.planPrice) + ' on every box + free e-book gift</b><br><small>Skip, pause or cancel before the next box is packed.</small></div><button type="button" data-monthly="' + (c.items.indexOf(hasBox) + 1) + '" data-plan="' + bp.plan + '">Switch</button></div>';
    }
    if (!html && hasBox) { var gb = list.filter(function (p) { return p.kind === 'ebook' && matches(p); })[0]; html = '<h4>Your free gift</h4><div class="mn-gift">' + (gb && gb.img ? '<img class="mn-gift__img" src="' + MN.esc(gb.img) + '" alt="" width="48" height="68">' : '<span class="mn-gift__ic" aria-hidden="true">🎁</span>') + '<div><b>Illustrated Play Plan e-book</b><small>Included free with your box. We email it as soon as you order.</small></div></div>'; }
    // 2) a kit or single item but no box: offer the matching box at the first-box price
    if (!html && hasKit && !hasBox) {
      var m = list.filter(function (p) { return p.kind === 'box' && p.available && matches(p); })[0];
      if (m) html = '<h4>Take it further</h4><div class="mn-upsell__row"><img src="' + MN.esc(m.img) + '" alt="" width="56" height="56"><div><b>' + MN.esc(m.title) + '</b><br><small>First box ' + MN.money(m.price - 1000) + ' with code FIRST25 <s>' + MN.money(m.price) + '</s></small></div><button type="button" data-upsell="' + m.vid + '" data-code="FIRST25">Add</button></div>';
    }
    // 3) a matching add-on, else any add-on not in the cart
    if (!html) {
      var pick = list.filter(function (p) { return p.kind === 'addon' && p.available && !inCart[p.pid] && matches(p); })[0] || list.filter(function (p) { return p.kind === 'addon' && p.available && !inCart[p.pid]; })[0];
      if (pick) html = '<h4>Complete the Nook</h4><div class="mn-upsell__row"><img src="' + MN.esc(pick.img) + '" alt="" width="56" height="56"><div><b>' + MN.esc(pick.title) + '</b><br><small>' + MN.money(pick.price) + '</small></div><button type="button" data-upsell="' + pick.vid + '">Add</button></div>';
    }
    if (!html) { box.hidden = true; return; }
    box.hidden = false; box.innerHTML = html;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-cart-open]'))) { e.preventDefault(); MN.openCart(); return; }
    if (t.closest('[data-close]') || t.id === 'mnOverlay') { MN.closeCart(); return; }
    var line = t.closest('.mn-line');
    if (line) {
      var n = parseInt(line.getAttribute('data-line'), 10), q;
      if ((el = t.closest('[data-qty]'))) { q = cartState.items[n - 1].quantity + parseInt(el.getAttribute('data-qty'), 10); MN.cart.change(n, q); }
      else if (t.closest('[data-remove]')) MN.cart.change(n, 0);
      return;
    }
    if ((el = t.closest('[data-monthly]'))) {
      el.disabled = true;
      json(MN.routes.cartChange + '.js', { method: 'POST', body: JSON.stringify({ line: parseInt(el.getAttribute('data-monthly'), 10), quantity: 1, selling_plan: parseInt(el.getAttribute('data-plan'), 10) }) }).then(function (c2) { cartState = c2; render(c2); MN.toast('Switched to monthly'); }).catch(function () { el.disabled = false; MN.toast('Could not switch, please try again'); });
      return;
    }
    if ((el = t.closest('[data-upsell]'))) {
      el.disabled = true; var code = el.getAttribute('data-code');
      Promise.resolve(code ? fetch('/discount/' + code, { credentials: 'same-origin' }).catch(function () {}) : 0).then(function () { return MN.cart.add([{ id: parseInt(el.getAttribute('data-upsell'), 10), quantity: 1 }]); }).then(function () { MN.toast('Added, nice choice 🐾'); });
      return;
    }
    if (t.closest('[data-menu-open]')) { $('#mnMenu').classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; return; }
    if (t.closest('[data-menu-close]')) { $('#mnMenu').classList.remove('is-open'); document.documentElement.style.overflow = ''; return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { MN.closeCart(); var m = $('#mnMenu'); m && m.classList.remove('is-open'); document.documentElement.style.overflow = ''; } });

  /* ---------- reveal ---------- */
  function initReveal() {
    var els = $$('[data-reveal]');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- parallax (scroll) ---------- */
  var plx = [];
  function initParallax() {
    if (reduce) return;
    plx = $$('[data-parallax]').map(function (el) { return { el: el, k: parseFloat(el.getAttribute('data-parallax')) || 0.2, axis: el.getAttribute('data-axis') || 'y' }; });
    if (!plx.length) return;
    var ticking = false;
    function tick() {
      var vh = window.innerHeight;
      plx.forEach(function (p) {
        var r = p.el.parentElement.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var mid = (r.top + r.height / 2) - vh / 2;
        var v = (-mid * p.k).toFixed(1);
        p.el.style.transform = p.axis === 'x' ? 'translate3d(' + v + 'px,0,0)' : 'translate3d(0,' + v + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(tick); } }, { passive: true });
    window.addEventListener('resize', tick); tick();
  }

  /* ---------- tilt cards ---------- */
  function initTilt() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    $$('[data-tilt]').forEach(function (el) {
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        el.style.transform = 'perspective(900px) rotateY(' + (x * 8).toFixed(2) + 'deg) rotateX(' + (-y * 8).toFixed(2) + 'deg) translateZ(0)';
      });
      el.addEventListener('pointerleave', function () { el.style.transform = ''; });
    });
  }

  /* ---------- counters ---------- */
  function initCounters() {
    var els = $$('[data-count]'); if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return; io.unobserve(en.target);
        var el = en.target, to = parseFloat(el.getAttribute('data-count')), dur = 1400, t0 = performance.now();
        if (reduce) { el.textContent = to; return; }
        (function step(t) { var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 4); el.textContent = Math.round(to * e); if (p < 1) requestAnimationFrame(step); })(t0);
      });
    }, { threshold: .4 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- header / announcement ---------- */
  function initHeader() {
    var h = $('.mn-header'); if (!h) return;
    var onScroll = function () { h.classList.toggle('is-stuck', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    var set = function () { document.documentElement.style.setProperty('--header-h', h.offsetHeight + 'px'); };
    set(); window.addEventListener('resize', set);
    var msgs = $$('.mn-announce__msg'); if (msgs.length > 1 && !reduce) {
      var i = 0; setInterval(function () { msgs[i].classList.remove('is-on'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-on'); }, 4200);
    }
  }

  /* ---------- add-to-cart forms: [data-mn-form] (simple) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-mn-quickadd]'); if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button[type=submit]'); btn && btn.classList.add('is-loading');
    var item = { id: parseInt(f.querySelector('[name=id]').value, 10), quantity: 1 };
    var sp = f.querySelector('[name=selling_plan]'); if (sp && sp.value) item.selling_plan = parseInt(sp.value, 10);
    MN.cart.add([item]).then(function () { MN.openCart(); }).catch(function (er) { MN.toast(er.message); }).finally(function () { btn && btn.classList.remove('is-loading'); });
  });

  function ready() { initReveal(); initParallax(); initTilt(); initCounters(); initHeader(); MN.cart.get().catch(function () {}); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
})();
